import apiService from './api.service'

/**
 * Tipo de contrassenha da empresa corrente e os textos do dialogo, ja do dicionario:
 * { tipo: 'SENHA_LOGIN', textos: { titulo, instrucao, campo, confirmar, cancelar } }. Tipo nulo = a empresa pede um
 * tipo que o back nao suporta (a operacao sera recusada).
 */
const buscarTelaContrassenha = () => apiService.get('/lottustech/contrassenha/tela')

export { buscarTelaContrassenha }
